const gamesPerStat = (stat, apps) => {
  return parseFloat(apps/stat).toFixed(1)
}

export default gamesPerStat